import { getMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_DOCTOR_DROP = 'GET_DOCTOR_DROP';
export const GET_DOCTOR_DROP_SUCCESS = 'GET_DOCTOR_DROP_SUCCESS';
export const GET_DOCTOR_DROP_FAILURE = 'GET_DOCTOR_DROP_FAILURE';

// Action Creators
export const getDoctorDropRequest = () => ({
  type: GET_DOCTOR_DROP,
});

export const getDoctorDropSuccess = (users) => ({
  type: GET_DOCTOR_DROP_SUCCESS,
  payload: users,
});

export const getDoctorDropFailure = (error) => ({
  type: GET_DOCTOR_DROP_FAILURE,
  payload: error,
});

// Thunk Function
export const getDoctorDrop = (external, countryId = '', stateId = '') => {
  return async (dispatch) => {
    dispatch(getDoctorDropRequest());
    try {
      const response = await getMethod(
        url?.helperData + '?country_id=' + countryId + '&state_id=' + stateId
      );
      // dispatch(getCitySuccess(response?.data));
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getDoctorDropSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getDoctorDropFailure(error?.message));
    }
  };
};
